import clsx from 'clsx';
import { ProductUSPItem } from '~/features/product-details/components/ProductOverview/components/ProductUSPItem/ProductUSPItem';
import { usePDPData } from '~/features/product-details/context';
import { isFreightByCarrier } from '~/lib/salesforce/utilities/shipping';
import { RawHtml, Typography } from '~/shared/components';
import { useTranslation } from '~/shared/utils/translation';
import styles from './ProductFreight.module.scss';
import { useFrame } from '~/shared/utils';

type Props = React.HTMLAttributes<HTMLDivElement>;

/**
 * Only products in a ship-by-carrier freight group carry this notice, so the check lives here
 * rather than as a flag every caller has to derive and pass down.
 */
export const ProductFreight: React.FC<Props> = ({ className, ...rest }) => {
    const { data: frame } = useFrame();
    const { translate } = useTranslation();
    const { product } = usePDPData();

    const freightUsps = frame.productSettings?.freightByCarrierUsp;

    if (!isFreightByCarrier(product.c_itemFreightGroup)) return null;

    return (
        <div className={clsx(styles.productFreight, className)} {...rest}>
            <Typography
                className={styles.productFreightHeadline}
                as="p"
                variant="paragraph-M"
                weight="medium"
            >
                {translate('pdp.freightByCarrier')}
            </Typography>

            {/* TODO: Confirm this once IMC-3278 is implemented in Umbraco. */}
            {freightUsps?.map((usp, index) => (
                <ProductUSPItem
                    className={styles.productFreightContent}
                    key={`freight-usp-${index}`}
                    icon={usp.icon}
                    label={<RawHtml html={usp.text} />}
                    tooltip={usp.tooltip}
                />
            ))}
        </div>
    );
};
